var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filesystem"},[_c('div',{staticClass:"filesystem__path"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.path)}})]),_c('filesystem-list',{attrs:{"objects":_vm.filesystem,"opened":true,"parent-path":''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }